import React from 'react';

import styles from './HistoryCheckSectionHeader.module.scss';

interface IHistoryCheckSectionHeader {
	parametersToShow: Record<string, string>;
}

const HistoryCheckSectionHeader = ({ parametersToShow }: IHistoryCheckSectionHeader) => {
	return (
		<div className={styles.parametersWrapper}>
			{Object.entries(parametersToShow).map(([key, value]) => {
				return (
					<div
						key={`${key}_${value}`}
						className={styles.sectionHeader}
					>
						{key}: <span>{value}</span>
					</div>
				);
			})}
		</div>
	);
};

export default HistoryCheckSectionHeader;
